"use strict";
var Backbone = require("backbone");
var _ = require("underscore");

var debug = require("debug")("views:ThumbnailsView"); //https://github.com/visionmedia/debug
var $ = require("jquery");


/**
 * ThumbnailsView: recherche et affiche le code que devra rentrer l'utilisateur pour décrypter le pdf
 */
module.exports = Backbone.View.extend({

    model: null, // documentModel
    authorizedPages: null,
    timer: null,
    cellsLoaded: null,
    nbCellsLoaded: 0,
    template:null, 
    templateCell: null,
    nbColumns: 0,
    cellWidth: 320,
    cellHeight: 280,
    nbCells: 0,
    enabled: false,
    isDouble: true,
    nbPages: 0,
    selectedCell: -1,
    page: 1,
    previousScrollPos: -1,
    STR: null,
    usePageLabel: false,

    events: {
        "click .rbn-thumbnails-cell": "onCellClicked",
        "scroll": "onScroll"
    },

    initialize: function (options) {
        var T = this;
        _.extend(T, options);

        T.cellsLoaded = [];

        // compile templates
        T.template = _.template(T.template);
        T.templateCell = _.template(T.templateCell), 

        T.listenTo(T.model, "sync", T.render);
    },

    loadCell: function (cell_idx, cell_el, preload) {
        var T = this;

        var pages_label, page;

        // on prend en compte la double page et la dernière page
        if(T.usePageLabel){
            if (T.isDouble) {
                page = cell_idx ? cell_idx * 2 : 1;
                if (page == 1) {
                    pages_label = T.model.pageLabelFromNumber(1);
                }
                else if (page == T.nbPages) {
                    pages_label = T.model.pageLabelFromNumber(page);
                }
                else {
                    pages_label = T.model.pageLabelFromNumber(page) + " - " + T.model.pageLabelFromNumber(page + 1);
                }
            }
            else {
                page = cell_idx + 1;
                pages_label = T.model.pageLabelFromNumber(page);
            }
        }
        else{
            if (T.isDouble) {
                page = cell_idx ? cell_idx * 2 : 1;
                if (page == 1) {
                    pages_label = "1";
                }
                else if (page == T.nbPages) {
                    pages_label = String(page);
                }
                else {
                    pages_label = String(page) + " - " + String(page + 1);
                }
            }
            else {
                page = cell_idx + 1;
                pages_label = String(page);
            }
        }

        var context = {
            STR: this.STR,
            thumbnailUrl: preload ? null : T.model.thumbnailUrl(page),
            pagesLabel: pages_label
        };
        $(cell_el).html(T.templateCell(context));
    },

    refresh: function () {
        var T = this;
        if (!T.enabled) return;

        // détermine les cellules visibles
        var offset = T.el.scrollTop;
 
        var first_cell = Math.floor(T.el.scrollTop / T.cellHeight) * T.nbColumns - T.preload; // pour avoir un préload
        var last_cell = Math.ceil((T.el.scrollTop + T.el.offsetHeight) / T.cellHeight) * T.nbColumns - 1 + T.preload; // pour avoir un préload
        if (last_cell >= T.nbCells) {
            last_cell = T.nbCells - 1;
        }
        if (first_cell < 0) {
            first_cell = 0;
        }
        for (var i = first_cell; i <= last_cell; i++) {
            if (!T.cellsLoaded[i]) {
                var cell_el = document.getElementById("c" + i);
                T.loadCell(i, cell_el);
                T.cellsLoaded[i] = true;
                T.nbCellsLoaded++;
            }
        }
        debug("refresh", offset, first_cell, last_cell, T.nbCellsLoaded);
    },

    resize: function () {
        var T = this;
        if (!T.enabled) return;
        debug("resize");
        T.computeColumns();

        var width_percent = 100 / T.nbColumns;

        for (var i = 0; i < T.nbCells; i++) {
            var $cell_el = T.$("#c" + String(i));
            $cell_el[0].style.width = width_percent + "%";
        }
        return T;
    },

    onResize: function () {
        var T = this;
        T.resize();
        T.refresh();
        return T;
    },

    selectPage: function (page) {
        var T = this, cell_index;

        var select_class = "rbn-selected";
        if (T.isDouble) {
            cell_index = Math.floor(page / 2);
        }
        else {
            cell_index = page - 1;
        }

        var $cell_selected = T.$("#c" + T.selectedCell);
        $cell_selected.removeClass(select_class);
        var $cell = T.$("#c" + cell_index);
        $cell.addClass(select_class);

        // rend la cellule visible si ce n'est pas déjà le cas
        var line_y = Math.floor(cell_index / T.nbColumns) * T.cellHeight;

        if (line_y < T.el.scrollTop || line_y + T.cellHeight > T.el.scrollTop + T.el.offsetHeight) {
            // on déplace seulement si on la cellule n'est pas totalement visible
            T.el.scrollTop = line_y;
        }

        T.selectedCell = cell_index;
    },

    onScroll: function () {
        var T = this;
        if (T.timer) {
            clearTimeout(T.timer);
            T.timer = null;
        }
        if (Math.abs(T.previousScrollPos - T.el.scrollTop) < 10) {
            T.refresh();   // prise en compte de la vitesse, ici la décélération
        }
        else {
            T.timer = setTimeout(function () { T.refresh(); }, 50); // on attends n ms avant de refaire le cacul des celluyles à charger
        }

        T.previousScrollPos = T.el.scrollTop;
    },

    onCellClicked: function (e) {
        var page, cell, T = this;
        cell = Number(e.currentTarget.id.substr(1));
        if (T.isDouble) {
            if (cell == 0) {
                page = 1;
            }
            else if (cell == T.nbCells - 1) {
                page = cell * 2;
            }
            else {
                page = cell * 2;

                // left or right side ?
                var rect = e.currentTarget.getBoundingClientRect();
                var x = e.clientX - rect.left;
                if (x > rect.width / 2) { // left or right side ?
                    page++;
                }
                //debug("x position " + x);
            }
        }
        else {
            page = cell + 1;
        }
        debug("cell clicked " + cell + " page " + page);
        this.trigger("click", page);
    },

    enable: function (enable, page) {
        var T = this;
        T.enabled = enable;
        if (enable) {
            if (!T.constructed) {
                T.construct();
            }
            T.resize();
            T.selectPage(page); // select current page and make it visible
            T.refresh();
        }
    },

    computeColumns: function () {
        var T = this;
        T.nbColumns = Math.floor(T.el.offsetWidth / T.cellWidth);
        if (T.nbColumns < 1) {
            T.nbColumns = 1;
        }

        T.isDouble = T.model.get("isDouble");
        T.nbPages = T.model.get("nbPages");
        T.nbCells = T.isDouble ? T.nbPages / 2 + 1 : T.nbPages;
        T.preload = T.nbColumns < 3 ? 3: T.nbColumns;
    },

    construct: function () {
        var T = this;
        var $grid_el = T.$(".rbn-thumbnails-grid");
        var cell_width_percent = 100 / T.nbColumns;

        for (var i = 0; i < T.nbCells; i++) {
            var cell_el = document.createElement("div");
            cell_el.classList.add("rbn-thumbnails-cell");
            cell_el.id = "c" + String(i);
            cell_el.style.height = T.cellHeight + "px";
            cell_el.style.width = cell_width_percent + "%";
            T.loadCell(i, cell_el, true);
            $grid_el[0].appendChild(cell_el);
            T.cellsLoaded[i] = false;
        }
        T.constructed = true;
    },

    render: function () {
        var T = this;
        debug("render");

        var context = {
            STR: T.STR
        };

        if (T.model.fetched) {
            T.$el.html(T.template(context));
            T.computeColumns();
            if (T.enabled) {
                T.construct();
            }
        }

        return T;
    },

    close: function () {
        var T = this;
        if (T.timer) {
            clearTimeout(T.timer);
            T.timer = null;
        }
        T.model = null;
        T.authorizedPages = null;
        T.stopListening();
        T.undelegateEvents();
    }

});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@immanens-com/pv5js/reader/views/thumbnails-view.js
// module id = 54
// module chunks = 0